// @flow

import React from 'react';
import { Grid, Container } from '@material-ui/core/';
import SignInContainer from '../../components/signin/container';
import SignInForm from '../../components/signin';

/*
import SignInInfo from '../../components/signin/info';
import HeroRight from '../../components/hero/right';
import SignupInfo from '../../components/signup/info';
import SignupForm from '../../components/signup';
import SignupMenu from '../../components/signup/menu';
import TabPanel from '../../components/tabpanel';*/

import './style.css';

function SignIn() {
    /*const [tabIndex, setTabIndex] = React.useState(0);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
    };
    const changeTabSignIn = e => {
        if (e) e.preventDefault();
        setTabIndex(0);
    };
    const changeTabSignup = (e) => {
        if (e) e.preventDefault();
        setTabIndex(1);
    };*/
    React.useEffect(() => {
        window.scrollTo(0, 0);
    });
    return (
        <Grid container className="sign">
            <Grid item sm={12} md={12} lg={12}>
                <SignInContainer>
                    <Container className="signin-container">
                        <SignInForm />
                    </Container>
                    {/*   <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        className="sign-tabs"
                    >
                        <Tab label="SIGN IN" />
                        <Tab label="SIGN UP" />
                    </Tabs>
                    <TabPanel value={tabIndex} index={0}>
                        <Container className="signin-container">
                            <SignInForm onSignupClick={changeTabSignup} />
                        </Container>
                    </TabPanel> 
                      <TabPanel value={tabIndex} index={1}> 
                    <Grid container className="signup-container">
                        <Grid item sm={7} md={7} lg={7}>
                            <SignupForm />
                        </Grid>
                        <Grid item sm={5} md={5} lg={5} className="side-menu">
                            <SignupMenu onSignInClick={changeTabSignIn} />
                        </Grid>
                    </Grid>
                      </TabPanel>*/}
                </SignInContainer>
            </Grid>
        </Grid>
    );
}

export default SignIn;
